import React, { useRef, useEffect, useState } from 'react';
import CgmToolTip from './CgmToolTip';
import CardiogramTooltip from './CardiogramTooltip';
import './TooltipBox.scss';

const TooltipBox = (props) => {
    const { containerClass, className} = props;
    const wrapperRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };

        window.addEventListener('click', handleClickOutside);
        return () => window.removeEventListener('click', handleClickOutside);
    }, []);

    return (
        <div className="tooltip-wrapper" ref={wrapperRef}>
            <div className="tooltip-area">
                <button
                    className="btn-tooltip"
                    onClick={(e) => {
                        e.stopPropagation();
                        setIsOpen(!isOpen);
                    }}
                >
                    <span className="blind">더 보기</span>
                </button>
                
                {isOpen && (
                    <div className={`tooltip-cont-wrapper active`}>
                        <div className={`tooltip-container ${containerClass || ''}`}>
                            { className === 'cgm' ? (
                                <>
                                    <CgmToolTip/>
                                </>
                            ) : (
                                <>
                                    <CardiogramTooltip/>
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default TooltipBox;
